import type { Address } from "@/apis/gql/types";
import { useTranslation } from "react-i18next";

import { supplierResearchPrompt } from "@/lib/prompts/supplier-research";

import {
  AssistantToolbar,
  AssistantToolbarAskAi,
  AssistantToolbarRoot,
  AssistantToolbarTrigger,
} from "@/components/shared/toolbars/assistant-toolbar";

import { RawTextCell } from "./text";

type Props = {
  name: string;
  address?: Address;
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
};

export const SupplierCell = ({ name, address, className }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between">
      <AssistantToolbarRoot openDelay={300}>
        <AssistantToolbarTrigger
          className="text-left overflow-hidden whitespace-nowrap text-ellipsis cursor-pointer"
          asChild={false}
        >
          <RawTextCell
            value={name}
            tooltipSideOffset={20}
            className={className}
          />
        </AssistantToolbarTrigger>
        <AssistantToolbar side="right">
          <AssistantToolbarAskAi
            aiPrompt={supplierResearchPrompt(name, address)}
            label={t("ask_ai.extras.suppliers")}
            query={name}
            type="wordware"
          />
        </AssistantToolbar>
      </AssistantToolbarRoot>
    </div>
  );
};
